import { render, staticRenderFns } from "./InfoForm.vue?vue&type=template&id=9b31bc38&scoped=true"
import script from "./InfoForm.vue?vue&type=script&lang=js"
export * from "./InfoForm.vue?vue&type=script&lang=js"
import style0 from "./InfoForm.vue?vue&type=style&index=0&id=9b31bc38&prod&lang=scss&scoped=true"
import style1 from "./InfoForm.vue?vue&type=style&index=1&id=9b31bc38&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b31bc38",
  null
  
)

export default component.exports